import {
  createRouter,
  Link,
  type ErrorComponentProps,
  type NotFoundRouteProps,
} from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { Button } from "@op/sf-op";
import { useEffect } from "react";

const NotFoundComponent = ({ data }: NotFoundRouteProps) => {
  useEffect(() => {
    console.error(data);
  }, [data]);

  return (
    <div className="flex flex-col min-h-screen items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-2">
        <h1 className="text-heading-1 font-heading-1 text-subtext-color">
          404
        </h1>
        <p className="text-body font-body text-default-font">Page not found</p>
      </div>
      <Link className="contents" to="/">
        <Button variant="brand-secondary">Back to safety</Button>
      </Link>
    </div>
  );
};

const ErrorComponent = ({ error }: ErrorComponentProps) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col min-h-screen items-center justify-center gap-2">
      <div className="flex flex-col items-center justify-center gap-2">
        <h1 className="text-heading-1 font-heading-1 text-subtext-color">
          500
        </h1>
        <p className="text-body font-body text-default-font">
          Something went wrong on our end. Please try again later or contact us.
        </p>
      </div>
      <Link className="contents" to="/">
        <Button variant="brand-secondary">Back to safety</Button>
      </Link>
    </div>
  );
};

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    defaultNotFoundComponent: NotFoundComponent,
    defaultErrorComponent: ErrorComponent,
  });

  return router;
};
